<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: "akira";
  src: local("akira"),
   url("./assets/font/akira.otf") format("truetype");
}

#app {
  font-family: 'akira';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html,body
{
  width: 100%;
  height: 100%;
  background: #1e1e1e !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue